<template lang="pug">
  header.header(:class="{scrolled: scrolled}")
    .bg
      .wrapper
        section.col1
          HeaderSocial
        section.col2
          Logo(:brand="config.site")
        section.col3
          HeaderDigitalPaper
      .container-navigation
        .wrapper-navigation
          Navigation
    .navigation-inner
      Branding(:brand="config.brand", :sponsor="config.sponsor", :lab="config.lab", :special="config.special")
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import Navigation from '@/components/Navigation'
import Logo from '@/components/Logo'
import HeaderDigitalPaper from '@/components/HeaderDigitalPaper'
import HeaderSocial from '@/components/HeaderSocial'
import Branding from '@/components/Branding'

export default  {
  name: 'Header',
  components: {
    Navigation,
    Logo,
    HeaderDigitalPaper,
    HeaderSocial,
    Branding
  },
  data() {
    return {
      scrollY: null,
      scrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', _.throttle(this.throttledScroll, 250));
  },
  methods: {
    throttledScroll() {
      const headerHeight = this.$el.getBoundingClientRect().height
      if(headerHeight < window.scrollY){
        this.scrolled = true
      } else {
        this.scrolled = false
      }
    }
  },
  computed: mapState([
    'config'
  ])
}
</script>

<style scoped lang="scss">
  .header {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 6;
    will-change: transform;
    transition: all .3s;
    @media all and (max-width: 900px){
      transform: translateY(-90px);
    }
    &.scrolled{
      @media all and (min-width: 900px){
        transform: translateY(-90px);
      }
    }
    .bg{
      background-color: white;
      border-bottom: 1px solid #dedede;
      padding-top: 25px;
    }
  }
  .wrapper{
    margin: 0 auto;
    max-width: 1170px;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 400px auto 400px;
    align-items: flex-end;
  }

  .container-navigation{
    border-top: 1px solid #dedede;
  }
  .wrapper-navigation{
    margin: 0 auto;
    max-width: 1170px;
    padding: 20px 0;
  }
  .col2{
    padding-bottom: 20px;
  }
</style>
